import useIsMobile from "../../../../hooks/useIsMobile";

const LOGOS_LENGTH = 25;

const LOGOS = Array.from({ length: LOGOS_LENGTH }, (_, i) => i + 2);

const logosStyle = (logo, isMobile) => {
  if (!isMobile) {
    // ledesma
    if ([25].includes(logo)) {
      return {
        // transform: "scale(2)",
        height: "calc(100vw / 15)",
      };
    }
    // agrandar menardi, la cerradura, alamo, aca, gestion
    if ([5, 7, 19, 22, 23].includes(logo)) {
      return { height: "calc(100vw / 25)" };
    }

    // achicar paviotti, canadez, lehman, cafe ruiz
    if ([2, 16, 21, 18, 24].includes(logo)) {
      return { height: "calc(100vw / 35)" };
    }

    if ([1, 3, 20].includes(logo)) {
      return { height: "calc(100vw / 40)" };
    }

    return {};
  } else {
    // ledesma
    if ([25].includes(logo)) {
      return {
        height: "calc(100vw / 8)",
      };
    }
    // agrandar menardi, la cerradura, alamo, aca, gestion
    if ([5, 7, 19, 22, 23].includes(logo)) {
      return { height: "calc(100vw / 10)" };
    }

    // achicar paviotti, canadez, lehman, cafe ruiz
    if ([2, 16, 21, 18, 24].includes(logo)) {
      return { height: "calc(100vw / 14)" };
    }
    // cafe ruiz, lehmann, UAA
    if ([1, 3, 20].includes(logo)) {
      return { height: "calc(100vw / 16)" };
    }

    return { height: "calc(100vw / 12)" };
  }
};

export const ClientsSection = () => {
  const isMobile = useIsMobile();

  return (
    <>
      <div className="centered-section" style={{ marginBlock: "7rem" }}>
        <span
          className="horizontal gap-8"
          style={{
            marginInline: "auto",
            width: "fit-content",
          }}
        >
          <span className="linea-negra"></span>
          <span className="columna">
            <p className="datos-upper-text">
              Clientes que accionan con datos, no con corazonadas
            </p>
            <span className="datos-upper-text">
              <b>Mirá quienes nos eligen.</b> Vos también podés estar acá
            </span>
          </span>
          <span className="linea-negra"></span>
        </span>
        {/* <span className="logos">
          <span className="clientes-logos gap-24">
            <img
              alt="cli-01"
              src={`${process.env.PUBLIC_URL}/assets/logos/logocliente1-04.png`}
            />
            <img
              alt="cli-02"
              src={`${process.env.PUBLIC_URL}/assets/logos/logocliente2-05.png`}
            />
            <img
              alt="cli-03"
              src={`${process.env.PUBLIC_URL}/assets/logos/logocliente3-06.png`}
            />
            <img
              alt="cli-04"
              src={`${process.env.PUBLIC_URL}/assets/logos/logocliente4-07.png`}
            />
            <img
              alt="cli-05"
              src={`${process.env.PUBLIC_URL}/assets/logos/logocliente5-08.png`}
            />
            <img
              alt="cli-06"
              src={`${process.env.PUBLIC_URL}/assets/logos/logocliente6-09.png`}
            />
          </span>
          <span className="clientes-logos gap-24">
            <img
              alt="cli-01"
              src={`${process.env.PUBLIC_URL}/assets/logos/logocliente1-04.png`}
            />
            <img
              alt="cli-02"
              src={`${process.env.PUBLIC_URL}/assets/logos/logocliente2-05.png`}
            />
            <img
              alt="cli-03"
              src={`${process.env.PUBLIC_URL}/assets/logos/logocliente3-06.png`}
            />
            <img
              alt="cli-04"
              src={`${process.env.PUBLIC_URL}/assets/logos/logocliente4-07.png`}
            />
            <img
              alt="cli-05"
              src={`${process.env.PUBLIC_URL}/assets/logos/logocliente5-08.png`}
            />
            <img
              alt="cli-06"
              src={`${process.env.PUBLIC_URL}/assets/logos/logocliente6-09.png`}
            />
          </span>
        </span> */}

        <span className="landing-logos">
          <span
            className="landing-clientes-logos"
            style={{ paddingLeft: "2rem" }}
          >
            {LOGOS.map((logo) => {
              return (
                <img
                  key={`1-${logo}`}
                  alt={`cli-${logo}`}
                  src={`${process.env.PUBLIC_URL}/assets/clientes/logoclientes-${logo}.png`}
                  style={logosStyle(logo, isMobile)}
                />
              );
            })}
          </span>
          <span
            className="landing-clientes-logos"
            style={{ paddingLeft: "2rem" }}
          >
            {LOGOS.map((logo) => (
              <img
                key={`1-${logo}`}
                alt={`cli-${logo}`}
                src={`${process.env.PUBLIC_URL}/assets/clientes/logoclientes-${logo}.png`}
                style={logosStyle(logo, isMobile)}
              />
            ))}
          </span>
        </span>
        {/* <button className="boton-generico boton-blanco">
          <p>Descubrí casos de éxito</p>
          <FaArrowRight />
        </button> */}
      </div>
      <section
        className="centered-section"
        style={{ marginBottom: 100, position: "relative" }}
      >
        <img
          src={`${process.env.PUBLIC_URL}/assets/imagenes/home/img_equipo2.png`}
          alt="simbolo-equipo"
          className="imagen-simbolo"
        />
        <span
          className="horizontal gap-8"
          style={{
            color: "white",
            marginInline: "auto",
            width: "fit-content",
          }}
        >
          <span className="linea-negra"></span>
          <p className="datos-upper-text">
            Con base sólida de conocimientos aplicados
          </p>
          <span className="linea-negra"></span>
        </span>
        <p
          className="section-title"
          style={{
            marginInline: "auto",
            textAlign: "center",
            margin: "2rem 0px",
          }}
        >
          Nuestro aporte, <br /> hace un{" "}
          <span style={{ color: "var(--red-highlight)" }}>servicio único</span>
        </p>
        <p className="section-subtitle" style={{ textAlign: "center" }}>
          Transformá tu negocio con el motor del cambio:
          <span className="underscore">
            {" "}
            los datos.
            <img
              alt="subrayado"
              src={`${process.env.PUBLIC_URL}/assets/imagenes/subrayado2-21.png`}
            />
          </span>
          <br />
          Tenemos un equipo apasionado por la innovación, que crea tecnología
          única y de vanguardia para
          <br />
          mejorar tu eficiencia y ayudarte a tomar decisiones con impacto real.
          Menos intuición.
          <br />
          Más información. Mejores resultados.
        </p>
      </section>
    </>
  );
};
